// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d4b327da","213":"2424f7e2","453":"ee6576ab"}[chunkId] + ".chunk.js";
};